function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Label } from './checkboxElements';
import { ToggleCore } from '../../core-components/ToggleCore';
export const Checkbox = /*#__PURE__*/React.forwardRef(({
  label,
  className,
  options = {},
  containerProps = {},
  ...props
}, fRef) => /*#__PURE__*/React.createElement(Label, _extends({
  "data-aui": "checkbox",
  className: className,
  multiline: options === null || options === void 0 ? void 0 : options.multiline
}, containerProps), /*#__PURE__*/React.createElement(ToggleCore, _extends({
  toggleType: "checkbox",
  ref: fRef
}, props), label)));